import React, { useState } from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { loginApi } from '../../../api/user';
import { useAuth } from '../../../hook';

import {
  Box,
  TextField,
  Typography,
  Container,
  Paper,
  Button,
  CircularProgress
} from '@mui/material';

export function LoginForm() {
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: ""
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Debes poner un email válido").required("El email es obligatorio"),
      password: Yup.string().required("El password es obligatorio")
    }),
    onSubmit: async (formValue) => {
      try {
        setLoading(true);
        const response = await loginApi(formValue);
        const { access } = response;
        login(access);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <Container maxWidth="xs">

        <Typography variant="h5" align="center" gutterBottom>
          Ingresa a tu cuenta
        </Typography>
        <Box component="form" onSubmit={formik.handleSubmit} noValidate>
          <TextField
            fullWidth
            label="Email o ID"
            name="email"
            type="email"
            margin="normal"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <TextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            margin="normal"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />

          <Button
            fullWidth
            variant="contained"
            
            type="submit"
            disabled={loading}
            sx={{
                mt: 3,
                paddingY: 2,
                backgroundColor: '#111111',
                fontSize: 17,
                fontWeight:300,
                textTransform: 'none',             
                '&:hover': {
                backgroundColor: '#444',
                },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Iniciar Sesión'}
          </Button>
        </Box>

    </Container>
  );
}
